import type { FC, ReactNode } from 'react'

import { ArrowUp } from 'lucide-react'
import { DiviMonogram, DiviWordmark } from '@/components/generals/divi-logo'

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-border'>
            <div className='mx-auto flex max-w-6xl flex-col gap-8 px-6 py-12 sm:flex-row sm:items-center sm:justify-between'>
                <div className='flex items-center gap-4'>
                    <DiviMonogram aria-hidden='true' className='size-11' />

                    <div>
                        <DiviWordmark tone='solid' aria-hidden='true' className='h-4 w-auto text-brand-red' />
                        <p className='mt-2 text-sm text-muted-foreground'>
                            Logo system, version 1.0
                        </p>
                    </div>
                </div>

                <div className='flex flex-col gap-4 sm:items-end'>
                    <a
                        href='#hero'
                        className='inline-flex w-fit items-center gap-2 rounded-full text-sm font-medium text-foreground transition-colors hover:text-brand-red focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-red'
                    >
                        Back to top
                        <ArrowUp aria-hidden='true' className='size-4' />
                    </a>

                    <p className='text-sm text-muted-foreground'>
                        © 2026 Divi. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}
